export { default } from './ArticleList';
